export default __webpack_public_path__ + "static/media/instagram.ffd8cd88.svg";